export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                随时随地，畅享漫画
              </h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6 max-w-md">
                支持电脑、平板、手机全平台访问。移动端自适应阅读模式，让你在地铁上、午休时、睡前都能轻松追漫。无需下载APP，浏览器打开即可畅读。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 text-foreground-800 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-smartphone-line text-lg"></i>
                  <span>手机端访问</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 rounded-full bg-primary-800/30 text-background-50 border border-primary-300/30 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-800/50 transition-colors">
                  <i className="ri-tablet-line text-lg"></i>
                  <span>平板端访问</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20manga%20reading%20app%20screen%2C%20Japanese%20comic%20page%20displayed%20on%20phone%2C%20warm%20orange%20and%20coral%20UI%20theme%2C%20clean%20modern%20interface%2C%20isometric%20view%2C%20soft%20shadow%2C%20professional%20product%20mockup%2C%20simple%20minimal%20background&width=500&height=900&seq=app-mobile-mockup&orientation=portrait"
                alt="移动端漫画阅读界面"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}